import { getPanelData } from '@/creditflowresearch/ui/common/constants/panelData';
import ColorizedPanel from '@/creditflowresearch/ui/common/components/molecules/ColorizedPanel';
import PageTopSection from '@/creditflowresearch/ui/common/components/templates/PageTopSection';
import { usePanelTools } from '@/creditflowresearch/ui/common/hooks/panels/usePanelTools';
import { usePanelSections } from '@/creditflowresearch/ui/common/hooks/panels/usePanelSections';
import { usePanelContentFilter } from '@/creditflowresearch/ui/common/hooks/panels/usePanelContentFilter';
import { useTitleWithLockIcon } from '@/creditflowresearch/ui/common/hooks/title/useTitleWithLockIcon';
import { getProductGradient } from '@/creditflowresearch/ui/common/utils/products/productStyleHelpers';
import { getExpandStrategy } from '@/creditflowresearch/domain/Header/Section/productExpandConfig';
import PanelTemplateDesktop from '@/creditflowresearch/ui/common/components/templates/PanelTemplate/PanelTemplateDesktop';
import PanelTemplateMobile from '@/creditflowresearch/ui/common/components/templates/PanelTemplate/PanelTemplateMobile';

interface IPanelContentProps {
  panelId: string,
  variant: 'desktop' | 'mobile',
}

const PanelContent = ({ panelId, variant }: IPanelContentProps) => {
  const panelData = getPanelData(panelId);
  const { selectedFilterId, filterButtonItems, handleFilterClick, getActiveItems } = usePanelContentFilter(panelId);
  const { topOptions, toolsOptions } = usePanelTools({ panelId, regionId: selectedFilterId });
  const sectionsGrid = usePanelSections({ panelId, regionId: selectedFilterId });
  const expandStrategy = getExpandStrategy(panelId);

  const formattedTitle = useTitleWithLockIcon({
    title: panelData?.header?.title || '',
    activeItems: getActiveItems(),
  });

  if (!panelData) {
    return null;
  }

  const headerPanel = (
    <ColorizedPanel style={ { background: getProductGradient(panelData.abbreviation) } }>
      <PageTopSection
        title={ formattedTitle }
        items={ filterButtonItems }
        onClick={ (item) => handleFilterClick(item) }
        titleDataTest="panelMenuTitle"
        sectionDataTest="panelMenuSection"
      />
    </ColorizedPanel>
  );

  return (
    <>
      { variant === 'desktop' ? (
        <PanelTemplateDesktop
          panelData={ panelData }
          headerPanel={ headerPanel }
          topOptions={ topOptions }
          toolsOptions={ toolsOptions }
          sectionsGrid={ sectionsGrid }
          expandStrategy={ expandStrategy }
        />
      ) : (
        <PanelTemplateMobile
          panelData={ panelData }
          headerPanel={ headerPanel }
          topOptions={ topOptions }
          toolsOptions={ toolsOptions }
          sectionsGrid={ sectionsGrid }
        />
      ) }
    </>
  );
};

export default PanelContent;
